<script lang="ts">
  import Radio from '$shared/atoms/Radio/Radio.svelte';

  interface Props {
    label?: string;
    name?: string;
    list?: CommonList[];
    tabIndex?: number;
    active?: string;
    onchange?: (item: CommonList) => void;
  }

  let {
    label = '',
    name = 'radio-group',
    list = [],
    tabIndex = 1,
    active = '',
    onchange
  }: Props = $props();

  const onChange = (item) => {
    onchange?.(item);
  };
</script>

<div data-cy={name} class="com-radio-group">
  {#if label}
    <div class="label">{label}</div>
  {/if}
  {#each list as item}
    <div class="radio-item">
      <Radio {item} active={active === item.id} {tabIndex} onchange={() => onChange(item)} />
    </div>
  {:else}
    <div class="empty">No option provided</div>
  {/each}
</div>

<style>
  .label {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 8px;
  }
  .radio-item:not(:last-child) {
    margin-bottom: 8px;
  }
  .empty {
    color: var(--grey-light);
    font-size: 12px;
    line-height: 20px;
  }
</style>
